export default function getFlowSuperProperties(applyData) {
  const superProperties = {
    is_mobile: applyData.is_mobile,
    layout: applyData.layout,
    method: applyData.method,
    resume_required: applyData.resume_required,
    ab_tests: applyData.ab_tests,
  };

  // jquery.log_event.js doesn't merge properties from frontend and backend, instead using just the
  // backend properties . This combines them so the backend properties don't overwrite the rest.
  if (window.zr?.event?.backendProperties?.ab_tests) {
    window.zr.event.backendProperties.ab_tests = {
      ...window.zr.event.backendProperties.ab_tests, ...applyData.ab_tests,
    };
  }

  return superProperties;
}
